// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1qldi","icon":"style_icon__13dTI","badge":"style_badge__32zLF"};